/**
 * 
 * 选对小工具路由模块
 */

export default [
    {
        path: '/xd_info',
        name: '加载中',
        component:() => import ('@/views/xuandui_gadgets/xd_person/index') ,
    },
    {
        path: '/xd_consult',
        name: '加载中',
        component:() => import ('@/views/xuandui_gadgets/xd_person/consult') ,
    },
    {
        path: '/xd_pay',
        name: '加载中',
        component:() => import ('@/views/xuandui_gadgets/xd_pay/index') ,
    },
    {
        path: '/xd_infomation',
        name: '加载中',
        component:() => import ('@/views/xuandui_gadgets/xd_infomation/index') ,
    },
    {
        path: '/xd_info_form',
        name: '加载中',
        component:() => import ('@/views/xuandui_gadgets/xd_infomation/form') ,
    },
    {
        path: '/xd_pay_succ',
        name: '加载中',
        component:() => import ('@/views/xuandui_gadgets/xd_pay_success/index') ,
    },
    {
        path: '/xd_pay_sform',
        name: '加载中',
        component:() => import ('@/views/xuandui_gadgets/xd_pay_success/form') ,
    },
    {
        path: '/xd_pay_qrcode',
        name: '加载中',
        component:() => import ('@/views/xuandui_gadgets/xd_pay_success/qrcode') ,
    },
    {
        path: '/xd_add_experience',
        name: '加载中',
        component:() => import ('@/views/xuandui_gadgets/xd_collection/add_experience') ,
    },
    {
        path: '/xd_add_eform',
        name: '加载中',
        component:() => import ('@/views/xuandui_gadgets/xd_collection/form') ,
    },
    {
        path: '/xd_ef',
        name: '加载中',
        component:() => import ('@/views/xuandui_gadgets/xd_collection/experience') ,
    },
    {
        path: '/xd_experience_list',
        name: '加载中',
        component:() => import ('@/views/xuandui_gadgets/xd_collection/list') ,
    },
    {
        path: '/xd_money',
        name: '加载中',
        component:() => import ('@/views/xuandui_gadgets/xd_money/index') ,
    },
    {
        path: '/xd_report_form',
        name: '加载中',
        component:() => import ('@/views/xuandui_gadgets/xd_ef_report/experience') ,
    },
    {
        path: '/xd_report_list',
        name: '加载中',
        component:() => import ('@/views/xuandui_gadgets/xd_ef_report/list') ,
    },
    {
        path: '/xd_consult_plan',
        name: '加载中',
        component:() => import ('@/views/xuandui_gadgets/consultation_scheme/plan') ,
    },
    {
        path: '/xd_consult_order',
        name: '加载中',
        component:() => import ('@/views/xuandui_gadgets/consultation_scheme/order') ,
    },
    {
        path: '/xd_consult_report',
        name: '加载中',
        component:() => import ('@/views/xuandui_gadgets/xd_consult_report/index') ,
    },
]